import $ from 'jquery'
import AirDatepicker from 'air-datepicker'

let chatbot = $('.bhub-ai-chatbot-widget')
let chat = chatbot.find('.bhub-ai-chatbot-widget--chat')
let message_list = chatbot.find('.bhub-ai-chatbot-widget--message-list')
let messages = chatbot.find('.bhub-ai-chatbot-widget--messages')
let form = chatbot.find('.bhub-ai-chatbot-widget--form')
let quickActions = chatbot.find('.bhub-ai-chatbot-widget--quick-actions')

// eslint-disable-next-line no-undef
const i18n = bookingHub

$(document).on('click', '.bhub-ai-chatbot-widget--trigger', function () {
  let trigger = $(this)
  chatbot.toggleClass('bhub-active')
  chat.toggleClass('bhub-active')
  trigger.toggleClass('bhub-active')
  trigger
    .closest('.bhub-ai-chatbot-widget')
    .find('.bhub-ai-chatbot-widget--bubble-text')
    .remove()

  if (!trigger.hasClass('bhub-loaded')) {
    toggleLoader()
    jQuery.post(
      bookingHub.ajaxUrl,
      { action: 'bhub/chatbot/get/chat', nonce: bookingHub.nonce },
      function (response) {
        if (response.chat_history) {
          chat.toggleClass('bhub-active-list')
          message_list.append(response.output)
        } else {
          form.attr('data-id', response.chat_id)
          messages.append(response.output)
        }
        toggleLoader()
        trigger.addClass('bhub-loaded')
      }
    )
  }
})

$(document).on(
  'click',
  '.bhub-ai-chatbot-widget--message-list--item',
  function () {
    let chat_id = $(this).attr('data-id')
    messages.empty()
    toggleLoader()
    quickActions.removeClass('bhub-active')
    form.attr('data-id', chat_id)

    jQuery.post(
      bookingHub.ajaxUrl,
      {
        action: 'bhub/chatbot/get/chat',
        chat_id: chat_id,
        nonce: bookingHub.nonce,
      },
      function (response) {
        chat.toggleClass('bhub-active-list')
        messages.append(response.output)
        messages.scrollTop(messages[0].scrollHeight - messages[0].clientHeight)
        toggleLoader()
      }
    )
  }
)

$(document).on('click', '.bhub-ai-chatbot-widget--close', function () {
  chat.toggleClass('bhub-active-list')
  quickActions.removeClass('bhub-active')

  toggleLoader()
  jQuery.post(
    i18n.ajaxUrl,
    { action: 'bhub/chatbot/get/chat', nonce: i18n.nonce },
    function (response) {
      message_list.empty()
      message_list.append(response.output)
      toggleLoader()
    }
  )
})

$(document).on('click', '.bhub-ai-chatbot-widget--close-chat', function () {
  chat.removeClass('bhub-active')
  chatbot.removeClass('bhub-active')
  chatbot.find('.bhub-ai-chatbot-widget--trigger').removeClass('bhub-active')
})

$(document).on(
  'click',
  '.bhub-ai-chatbot-widget--start-new-chat',
  function (e) {
    messages.empty()
    chat.removeClass('bhub-active-list')
    toggleLoader()

    jQuery.post(
      bookingHub.ajaxUrl,
      { action: 'bhub/chatbot/new/chat', nonce: bookingHub.nonce },
      function (response) {
        if (response.error) {
          bookingHub.notyf.error(response.message)
          return false
        }
        form.attr('data-id', response.chat_id)
        messages.append(response.output)
        message_list.append(response.output_list)
        messages.scrollTop(messages[0].scrollHeight - messages[0].clientHeight)
        toggleLoader()
      }
    )

    e.preventDefault()
  }
)

// Form Submit
$(document).on(
  'submit',
  '.bhub-ai-chatbot-widget .bhub-ai-chatbot-widget--form',
  function (e) {
    let form = $(this)
    form.addClass('bhub-is-working')
    let chat_id = form.attr('data-id')
    let result = messages
    let prompt = form.find('#prompt').val()
    let isNextstep = form.find('#prompt').attr('data-next')
    form.find('#prompt').val('')
    let message_id = Date.now()
    chatBotStop = false
    quickActions.removeClass('bhub-active')

    if (!isNextstep) {
      result.append(
        `<div class="bhub-ai-chatbot-widget--messages--message">${prompt}</div><time class="bhub-ai-chatbot-widget--messages--message-time" datetime="${getCurrentTimeFormatted()}">${bookingHub.i18n.nowStr}</time>`
      )
    }
    form.find('#prompt').removeAttr('data-next')
    result.scrollTop(result[0].scrollHeight - result[0].clientHeight)

    jQuery.post(
      bookingHub.ajaxUrl,
      {
        action: 'bhub/chatbot/get/chat_data',
        chat_id: chat_id,
        nonce: bookingHub.nonce,
      },
      function (response) {
        if (response.error) {
          bookingHub.notyf.error(response.message)
          result.append(
            `<div class="bhub-ai-chatbot-widget--messages--message ai text-${message_id}">${response.message}</div><time class="bhub-ai-chatbot-widget--messages--message-time ai" datetime="${getCurrentTimeFormatted()}">${bookingHub.i18n.nowStr}</time>`
          )
          result.scrollTop(result[0].scrollHeight - result[0].clientHeight)
          return false
        } else {
          result.append(
            `<div class="bhub-ai-chatbot-widget--messages--message ai text-${message_id}"><div class="bhub-ai-chatbot-widget--messages--message--loader"></div></div><time class="bhub-ai-chatbot-widget--messages--message-time ai" datetime="${getCurrentTimeFormatted()}">${bookingHub.i18n.nowStr}</time>`
          )
          result.scrollTop(result[0].scrollHeight - result[0].clientHeight)
          // asyncChatBot(prompt, result, message_id, response.data, chat_id)
          getResponse(prompt, result, message_id, response.data, chat_id)
        }
      }
    )

    e.preventDefault()
  }
)

$(document).on(
  'click',
  '.bhub-ai-chatbot-widget--quick-actions--button',
  function () {
    let prompt = $(this).attr('data-prompt')
    let form = $(this)
      .closest('.bhub-ai-chatbot-widget--chat')
      .find('.bhub-ai-chatbot-widget--form')

    form.find('#prompt').val(prompt)
    form.trigger('submit')
  }
)

$(document).on('click', '.bhub-chatbot-confirm-date', function () {
  let form = $(this)
    .closest('.bhub-ai-chatbot-widget--chat')
    .find('.bhub-ai-chatbot-widget--form')

  let dateField = $(this).closest('.bhub-form')
  let date = dateField.find('#bhub-date-picker').val()
  let hours = dateField.find('#bhub-hours-picker').val()

  let prompt = `Date: ${date} - Hours: ${hours}`

  form.find('#prompt').val(prompt)
  form.trigger('submit')
})

$(document).on('click', '.bhub-chatbot-confirm-daterange', function () {
  let form = $(this)
    .closest('.bhub-ai-chatbot-widget--chat')
    .find('.bhub-ai-chatbot-widget--form')

  let dateField = $(this).closest('.bhub-form')
  let daterange = dateField.find('.bhub-daterange-picker').val()

  let prompt = daterange

  console.log(prompt)

  form.find('#prompt').val(prompt)
  form.trigger('submit')
})

function getResponse(prompt, result, message_id, message_data, chat_id) {
  let message = result.find(
    '.bhub-ai-chatbot-widget--messages--message.text-' + message_id
  )
  let actions = result
    .parent()
    .find('.bhub-ai-chatbot-widget--quick-actions--list')

  jQuery.post(
    bookingHub.ajaxUrl,
    {
      action: 'bhub/chatbot/completions',
      chat_id: chat_id,
      prompt: prompt,
      nonce: bookingHub.nonce,
    },
    function (response) {
      if (!response.success) {
        bookingHub.notyf.error(response.data.message)
        return
      }
      message.html(response.data.message)

      if (response.data.nextStep) {
        let form = message
          .closest('.bhub-ai-chatbot-widget--chat')
          .find('.bhub-ai-chatbot-widget--form')

        form.find('#prompt').attr('data-next', 'true')
        form.find('#prompt').val('Next Step')
        form.trigger('submit')
        return false
      }
      if (response.data.actions != '') {
        actions.html(response.data.actions)
        quickActions.addClass('bhub-active')
      }

      // Date pickers
      const dateRangePicker = response.data.dateRangePicker

      if (dateRangePicker) {
        let datePickerElement = $('.bhub-date-picker')
        let datePickerHTML = response.data.dateRangePicker

        jQuery.post(
          bookingHub.ajaxUrl,
          {
            action: 'bhub/chatbot/get_date_collect',
            service_name: datePickerElement.attr('data-service'),
            room_name: datePickerElement.attr('data-room'),
            nonce: bookingHub.nonce,
          },
          function (response) {
            console.log('collect:', response)
            message.append(datePickerHTML)
            const service_id = response.data.service_id
            const currentDate = new Date().toISOString().slice(0, 10)
            const formattedDays =
              response.data.disabledDays &&
              response.data.disabledDays.map((date) => {
                return new Date(date)
              })
            // DateRange picker
            $('.bhub-daterange-picker').each(function () {
              new AirDatepicker(this, {
                classes: 'bhub-airdatepicker',
                locale: i18n.calendar.i18n,
                dateFormat: 'yyyy-MM-dd',
                autoClose: true,
                firstDay: bookingHub.firstDayOfTheWeek * 1,
                range: true,
                toggleSelected: false,
                dynamicRange: false,
                showOtherMonths: false,
                selectOtherMonths: false,
                fixedHeight: true,
                minDate: new Date(),
                onRenderCell: ({ date, cellType, datepicker }) => {
                  if ('day' !== cellType) return
                  if (date.getMonth() !== datepicker.viewDate.getMonth()) return

                  const isDisabled = formattedDays.some(
                    (disabledDate) =>
                      date.toLocaleDateString() ===
                      disabledDate.toLocaleDateString()
                  )

                  if (isDisabled) {
                    return {
                      disabled: true,
                    }
                  }
                },
                onSelect: ({ formattedDate, datepicker, date }) => {},
                buttons: [
                  {
                    content() {
                      return bookingHub.i18n.todayStr
                    },
                    onClick(datepicker) {
                      const today = new Date()
                      const disabled = datepicker.isDateDisabled(today)

                      if (disabled) {
                        datepicker.setViewDate(new Date())
                      } else {
                        datepicker.selectDate(today)
                      }
                    },
                  },
                ],
              })
            })
          }
        )
      }
      result.scrollTop(result[0].scrollHeight - result[0].clientHeight)
    }
  )
}

let chatBotStop = false
let asyncChatBot = async (
  prompt,
  result,
  message_id,
  message_data,
  chat_id
) => {
  let prompt_first = prompt
  let chunk = []
  let streaming = true
  let controller = null // Store the AbortController instance
  let message = result.find(
    '.bhub-ai-chatbot-widget--messages--message.text-' + message_id
  )

  controller = new AbortController()
  const signal = controller.signal

  const response = await fetch(atob(bookingHub.chatbot.guest_id), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization:
        'Bearer ' +
        atob(bookingHub.chatbot.guest_event_id) +
        atob(bookingHub.chatbot.guest_look_id) +
        atob(bookingHub.chatbot.guest_product_id),
    },
    body: JSON.stringify({
      model: 'gpt-4.1',
      messages: message_data.concat([{ role: 'user', content: prompt }]),
      stream: true, // For streaming responses
    }),
    signal, // Pass the signal to the fetch request
  })

  if (response.status != 200) {
    throw response
  }
  // Read the response as a stream of data
  const reader = response.body.getReader()
  const decoder = new TextDecoder('utf-8')

  while (true) {
    if (chatBotStop) {
      return // Exit the function
    }
    const { done, value } = await reader.read()
    if (done) {
      streaming = false
      break
    }
    // Massage and parse the chunk of data
    const chunk1 = decoder.decode(value)
    const lines = chunk1.split('\n')

    const parsedLines = lines
      .map((line) => line.replace(/^data: /, '').trim()) // Remove the "data: " prefix
      .filter((line) => line !== '' && line !== '[DONE]') // Remove empty lines and "[DONE]"
      .map((line) => {
        try {
          return JSON.parse(line)
        } catch (ex) {
          console.log(line)
        }
        return null
      }) // Parse the JSON string

    for (const parsedLine of parsedLines) {
      if (!parsedLine) continue
      const { choices } = parsedLine
      const { delta } = choices[0]
      const { content } = delta
      // const { finish_reason } = choices[0];

      if (content) {
        chunk.push(content)
        message.append(content.replace(/(?:\r\n|\r|\n)/g, ' <br> '))
        result.scrollTop(result[0].scrollHeight - result[0].clientHeight)
      }
    }
  }
  jQuery.post(
    bookingHub.ajaxUrl,
    {
      action: 'bhub/chatbot/save/chat',
      prompt: prompt_first,
      message: chunk.join(''),
      chat_id: chat_id,
      nonce: bookingHub.nonce,
    },
    function (response) {
      result.scrollTop(result[0].scrollHeight - result[0].clientHeight)
      form.removeClass('bhub-is-working')
    }
  )
}

function toggleLoader() {
  chatbot.toggleClass('bhub-is-loading')
}

function getCurrentTimeFormatted() {
  const now = new Date()

  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
